import Geolocation from './GeolocationService';
import Language from './LanguageService';

export { default as Geolocation } from './GeolocationService';
export { default as Language } from './LanguageService';

export default {
  Geolocation,
  Language,
};
